const babbel = {
  public_id: "",
  template: "babbel",
  campaign: "",
  name: "Babbel",
  flow: "PIN_FLOW",
  approach: "DEFAULT",
  country_code: "gb",
  country_name: "UK",

  // Branding
  logo_url: "https://canada.noju.io/p/static/00/images/Babbel-logo-in-orange%202.webp",
  logo_position: "CENTER",
  logo_size: "Small",
  logo_under_button: false,

  // Colors
  titles_color: "#000000",
  text_color: "black",
  button_text_color: "white",
  button_primary_color: "#FF6600",
  background_color: "#FFF",
  header_background_color: "#FFF",
  footer_bg_color: "#000",
  footer_text_color: "#FFF",

  // Images
  featured_image: "https://canada.noju.io/p/static/00/images/hero-lifestyle.png",
  player_image: "",

  // Footer
  show_footer: true,
  footer_content: '<span style="color: #FFF;">Powered by</span> <a href="https://dcb-checkout.com" target="_blank" style="text-decoration: none; color: #fff; font-weight: bold;">DCB <span style="background: linear-gradient(92.32deg, #7538F0 -3.12%, #F233E7 100.39%); -webkit-background-clip: text; -webkit-text-fill-color: transparent;">CHECKOUT</span></a>',

  // UI Settings
  layout: "FULL_WIDTH",
  button_font_size: "20px",
  show_rating: true,
  show_country_flag: true,
  show_step_indicator: true,
  animation_enabled: false,
  validate_msisdn: true,

  // Legal
  terms_url: "https://mobilecheckout.shop/terms-of-service.html",
  policy_url: "https://mobilecheckout.shop/privacy-policy.html",
  contact_us_url: "contact-us.html"
};

export default babbel;
